import APIService from "@/services/APIService.js";

export default {
  getAllIndices(nomeIndice = 'IPCA') {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`/indicesAtualizacao/getAllIndices/${nomeIndice}`)
      .then(response => {
        let indices = response.data.data;
        resolve({
          indices,
          'ultimoRegistroOficial': indices ? ( (indices.find(item => item.IndiceOficial == 'Sim'))?.DataRegistro ) : [],
          'ultimoRegistroNaoOficial': indices ? ( (indices.find(item => item.IndiceOficial == 'Não'))?.DataRegistro ) : []
        });
      })
      .catch(error => reject(error));
    });
  },
  getUltimoIndiceIpca() {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`/indicesAtualizacao/getUltimoIndiceIpca`)
      .then(response => {
        let rData = response?.data?.data;
        let indice = {};
        rData.forEach(item => {
          item.IndiceOficial == 'Sim' ? indice.indice_oficial = item : indice.indice_estimado = item;
        });
        resolve(indice);
      })
      .catch(error => reject(error));
    })
  },
  getIndiceByDataRegistro(id) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`/indicesAtualizacao/getIndiceIpca/${id}`)
      .then(response => {
        let rData = response?.data?.data;
        let indice = {};
        rData.forEach(item => {
          item.IndiceOficial == 'Sim' ? indice.indice_oficial = item : indice.indice_estimado = item;
        });
        resolve(indice);
      })
      .catch(error => reject(error));
    })
  },
  deletarMultiplos(postData) {
    return APIService.apiCall().post('/indicesAtualizacao/excluirMultiplosIndices', JSON.stringify(postData));
  },
  getArquivoModelo() {
    return APIService.apiCall().get('/indicesAtualizacao/downloadArquivoModelo', {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },
  salvar(postData) {
    return APIService.apiCall().post(`/indicesAtualizacao/salvar`, JSON.stringify(postData));
  },
  salvarIpcaEstimado(postData) {
    return APIService.apiCall().post('/indicesAtualizacao/salvarIpcaEstimado', JSON.stringify(postData));
  },
  deletar(dataRegistro){
    return APIService.apiCall().get(`/indicesAtualizacao/excluirIndiceIpca/${dataRegistro}`);
  },
  deletarMultiplos(postData) {
    return APIService.apiCall().post('/indicesAtualizacao/excluirMultiplosIndicesIpca', JSON.stringify(postData));
  }
};